var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var debugBuild = require('../debug-build.js');
var envelope = require('../utils-hoist/envelope.js');
var logger = require('../utils-hoist/logger.js');
var ratelimit = require('../utils-hoist/ratelimit.js');
var MIN_DELAY = 100; // 100 ms
var START_DELAY = 5000; // 5 seconds
var MAX_DELAY = 3.6e6; // 1 hour

/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */
function makeOfflineTransport(createTransport) {
  function log() {
    var _logger$logger;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    debugBuild.DEBUG_BUILD && (_logger$logger = logger.logger).info.apply(_logger$logger, ['[Offline]:'].concat(args));
  }
  return function (options) {
    var transport = createTransport(options);
    if (!options.createStore) {
      throw new Error('No `createStore` function was provided');
    }
    var store = options.createStore(options);
    var retryDelay = START_DELAY;
    var flushTimer;
    function shouldQueue(env, error, retryDelay) {
      // We want to drop client reports because they can be generated when we retry sending events while offline.
      if (envelope.envelopeContainsItemType(env, ['client_report'])) {
        return false;
      }
      if (options.shouldStore) {
        return options.shouldStore(env, error, retryDelay);
      }
      return true;
    }
    function flushIn(delay) {
      if (flushTimer) {
        clearTimeout(flushTimer);
      }
      flushTimer = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var found;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              flushTimer = undefined;
              _context.next = 3;
              return store.shift();
            case 3:
              found = _context.sent;
              if (found) {
                log('Attempting to send previously queued event');

                // We should to update the sent_at timestamp to the current time.
                found[0].sent_at = new Date().toISOString();
                void send(found, true).catch(function (e) {
                  log('Failed to retry sending', e);
                });
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })), delay);

      // We need to unref the timer in node.js, otherwise the node process never exit.
      if (typeof flushTimer !== 'number' && flushTimer.unref) {
        flushTimer.unref();
      }
    }
    function flushWithBackOff() {
      if (flushTimer) {
        return;
      }
      flushIn(retryDelay);
      retryDelay = Math.min(retryDelay * 2, MAX_DELAY);
    }
    function send(_x) {
      return _send.apply(this, arguments);
    }
    function _send() {
      _send = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(envelope$1) {
        var isRetry,
          result,
          delay,
          _result$headers,
          _result$headers2,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isRetry = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
              if (!(!isRetry && envelope.envelopeContainsItemType(envelope$1, ['replay_event', 'replay_recording']))) {
                _context2.next = 6;
                break;
              }
              _context2.next = 4;
              return store.push(envelope$1);
            case 4:
              flushIn(MIN_DELAY);
              return _context2.abrupt("return", {});
            case 6:
              _context2.prev = 6;
              _context2.t0 = options.shouldSend;
              if (!_context2.t0) {
                _context2.next = 13;
                break;
              }
              _context2.next = 11;
              return options.shouldSend(envelope$1);
            case 11:
              _context2.t1 = _context2.sent;
              _context2.t0 = _context2.t1 === false;
            case 13:
              if (!_context2.t0) {
                _context2.next = 15;
                break;
              }
              throw new Error('Envelope not sent because `shouldSend` callback returned false');
            case 15:
              _context2.next = 17;
              return transport.send(envelope$1);
            case 17:
              result = _context2.sent;
              delay = MIN_DELAY;
              if (!result) {
                _context2.next = 30;
                break;
              }
              if (!((_result$headers = result.headers) !== null && _result$headers !== void 0 && _result$headers['retry-after'])) {
                _context2.next = 24;
                break;
              }
              delay = ratelimit.parseRetryAfterHeader(result.headers['retry-after']);
              _context2.next = 30;
              break;
            case 24:
              if (!((_result$headers2 = result.headers) !== null && _result$headers2 !== void 0 && _result$headers2['x-sentry-rate-limits'])) {
                _context2.next = 28;
                break;
              }
              delay = 60000; // 60 seconds
              _context2.next = 30;
              break;
            case 28:
              if (!((result.statusCode || 0) >= 400)) {
                _context2.next = 30;
                break;
              }
              return _context2.abrupt("return", result);
            case 30:
              flushIn(delay);
              retryDelay = START_DELAY;
              return _context2.abrupt("return", result);
            case 35:
              _context2.prev = 35;
              _context2.t2 = _context2["catch"](6);
              _context2.next = 39;
              return shouldQueue(envelope$1, _context2.t2, retryDelay);
            case 39:
              if (!_context2.sent) {
                _context2.next = 52;
                break;
              }
              if (!isRetry) {
                _context2.next = 45;
                break;
              }
              _context2.next = 43;
              return store.unshift(envelope$1);
            case 43:
              _context2.next = 47;
              break;
            case 45:
              _context2.next = 47;
              return store.push(envelope$1);
            case 47:
              flushWithBackOff();
              log('Error sending. Event queued.', _context2.t2);
              return _context2.abrupt("return", {});
            case 52:
              throw _context2.t2;
            case 53:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[6, 35]]);
      }));
      return _send.apply(this, arguments);
    }
    if (options.flushAtStartup) {
      flushWithBackOff();
    }
    return {
      send: send,
      flush: function flush(timeout) {
        // If there's no timeout, we should attempt to flush the offline queue.
        if (timeout === undefined) {
          retryDelay = START_DELAY;
          flushIn(MIN_DELAY);
        }
        return transport.flush(timeout);
      }
    };
  };
}
exports.MIN_DELAY = MIN_DELAY;
exports.START_DELAY = START_DELAY;
exports.makeOfflineTransport = makeOfflineTransport;